import './App.css';
import Home from './pages/Home';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import "react-datepicker/dist/react-datepicker.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
}
  from 'react-router-dom';
import ProviderDetails from './pages/provider/ProviderDetails';
import WebContent from './components/webComp/WebContent';
import GameList from './pages/game/GameList';
import ProviderList from './pages/provider/ProviderList';
import WebFavourities from './components/webComp/WebFavourites'
import BetList from './pages/bet/BetList';
import { removeUserDetails } from './redux/slices/UserDetailSlice';
import { setAuthModal, setAuthType } from './redux/slices/authSlice';
import GeneralService from './apis/GeneralService';
import ApiURL from './apis/ApiURL';


function App() {
  const _privateState = useSelector((state) => state);
  
  const dispatch = useDispatch();
  useEffect(() => {
    function autoLogin() {
      dispatch(setAuthModal(false));
      dispatch(setAuthType('login'))
    }
    function autoLogOut() {
      dispatch(removeUserDetails());
      dispatch(setAuthModal(true));
      dispatch(setAuthType('login'))
    }
    let token = _privateState?.userDetailState?.user_details?.token || null;
    if (!token) {
      //IF TOKEN NOT FOUND 
      autoLogOut();
    } else {
      //API TOEK CHECK FROM BACKEND 
      GeneralService.isTokenAlive(`${ApiURL.isTokenAlive}`, { token }).then(res => {
        
        if (res.error == true) {
          autoLogOut();
        } else {
          autoLogin();
        }
      }).catch(error => {
        console.log(error);
      });
      // Once we have the isTokenAlive API integration completed, then only we will remove this below function 
      // autoLogin();
    }

  }, [])
  return (
    <Router>
      <Routes>
        {/* <Route path='/login' element={<Login />} /> */}
        <Route path='/' element={<Home />} >
          <Route index element={<WebContent />} />
          <Route path='/provider-list' element={<ProviderList />} />
          <Route path='/provider-detail' element={<ProviderDetails />} />
          <Route path='/games/favourites' element={<WebFavourities />} />
          <Route path='/games/:game_category' element={<GameList />} />
          <Route path='/games/:game_category/:provider_id' element={<GameList />} />
          <Route path='/bet-history' element={<BetList />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
